import client from '@/graphql/client'
import { apolloClient } from '@/vue-apollo'
import ListChatLog from '@/graphql/queries/ListChatLog'
import ClearChatLog from '@/graphql/mutations/ClearChatLog'
import CreateChatLog from '@/graphql/mutations/CreateChatLog'
import OnCreateChatLog from '@/graphql/subscriptions/OnCreateChatLog'

export const chatLog = {
  namespaced: true,
  state: {
    chatLog: []
  },
  mutations: {
    setChatLog (state, payload) {
      state.chatLog = payload
    },
    addChatLog (state, payload) {
      const index = state.chatLog.findIndex((log) => log.id === payload.id)
      if (index === -1) {
        state.chatLog.unshift(payload)
      }
    }
  },
  actions: {
    async createChatLog ({ commit }, { projectId, input }) {
      try {
        const data = await client.query({
          operationName: 'createChatLog',
          query: CreateChatLog,
          variables: { projectId, input }
        })

        commit('addChatLog', data.createChatLog)
        return data.createChatLog
      } catch (e) {
        console.log(e)
      }
    },

    async listChatLog ({ commit }, { workflowId }) {
      try {
        const data = await client.query({
          operationName: 'listChatLog',
          query: ListChatLog,
          variables: { workflowId }
        })

        commit('setChatLog', data.listChatLog)

        apolloClient.subscribe({
          query: OnCreateChatLog,
          variables: { workflowId },
          fetchPolicy: 'no-cache'
        }).subscribe({
          next (res) {
            commit('addChatLog', res.data.onCreateChatLog)
          },
          error (error) {
            console.error('Subscription error:', error)
          }
        })

        return data.listChatLog
      } catch (e) {
        console.log(e)
      }
    },

    async clearChatLog ({ commit }, { projectId, workflowId }) {
      try {
        const data = await client.query({
          operationName: 'clearChatLog',
          query: ClearChatLog,
          variables: { projectId, workflowId }
        })

        if (data?.clearChatLog) {
          commit('setChatLog', [])
          commit('snackbar/showMessage', { content: 'Chat log history has been cleared!' }, { root: true })
          return data.clearChatLog
        }
      } catch (e) {
        console.log(e)
        commit('snackbar/showMessage', {
          content: e?.message || 'Failed to clear chat log',
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    }
  }
}
